import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-444ce93f")

_pushScopeId("data-v-444ce93f")
const _hoisted_1 = { id: "textInputEditor" }
const _hoisted_2 = { class: "settings-row" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Placeholder", -1)
const _hoisted_4 = { class: "settings-row" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Default input", -1)
const _hoisted_6 = { class: "settings-row" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Max input length", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "label heading" }, "Text-Style", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "label heading" }, "Position", -1)
const _hoisted_11 = { class: "settings-row" }
const _hoisted_12 = { class: "input-box" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode()
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, "X", -1)
const _hoisted_15 = { class: "input-box" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode()
const _hoisted_17 = /*#__PURE__*/_createVNode("span", null, "W", -1)
const _hoisted_18 = { class: "settings-row" }
const _hoisted_19 = { class: "input-box" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode()
const _hoisted_21 = /*#__PURE__*/_createVNode("span", null, "Y", -1)
const _hoisted_22 = { class: "input-box" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode()
const _hoisted_24 = /*#__PURE__*/_createVNode("span", null, "H", -1)
const _hoisted_25 = { class: "settings-row" }
const _hoisted_26 = { class: "input-box" }
const _hoisted_27 = /*#__PURE__*/_createVNode("span", null, "Padding", -1)
const _hoisted_28 = { style: {"margin-top":"15px"} }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" The user's input of this component is available through the placeholder ")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(". You will need to have PlaceholderAPI installed for the placeholder to work. ")
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_color_input = _resolveComponent("color-input")
  const _component_font_editor = _resolveComponent("font-editor")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_color_input, {
      label: "Background color",
      color: _ctx.component.backgroundColor,
      "onUpdate:color": _cache[1] || (_cache[1] = $event => (_ctx.component.backgroundColor = $event))
    }, null, 8, ["color"]),
    _createVNode(_component_color_input, {
      label: "Active background color",
      color: _ctx.component.backgroundColorActive,
      "onUpdate:color": _cache[2] || (_cache[2] = $event => (_ctx.component.backgroundColorActive = $event))
    }, null, 8, ["color"]),
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.component.placeHolder = $event))
      }, null, 512), [
        [_vModelText, _ctx.component.placeHolder]
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      _withDirectives(_createVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (_ctx.component.defaultInput = $event))
      }, null, 512), [
        [_vModelText, _ctx.component.defaultInput]
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _hoisted_7,
      _withDirectives(_createVNode("input", {
        type: "number",
        style: {"max-width":"40px"},
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (_ctx.component.maxLength = $event))
      }, null, 512), [
        [
          _vModelText,
          _ctx.component.maxLength,
          void 0,
          { number: true }
        ]
      ])
    ]),
    _hoisted_8,
    _hoisted_9,
    _createVNode(_component_color_input, {
      color: _ctx.component.fontColor,
      "onUpdate:color": _cache[6] || (_cache[6] = $event => (_ctx.component.fontColor = $event))
    }, null, 8, ["color"]),
    _createVNode(_component_color_input, {
      label: "Placeholder Color",
      color: _ctx.component.fontColorPlaceholder,
      "onUpdate:color": _cache[7] || (_cache[7] = $event => (_ctx.component.fontColorPlaceholder = $event))
    }, null, 8, ["color"]),
    _createVNode(_component_font_editor, {
      font: _ctx.component.font,
      "onUpdate:font": _cache[8] || (_cache[8] = $event => (_ctx.component.font = $event)),
      size: _ctx.component.size,
      "onUpdate:size": _cache[9] || (_cache[9] = $event => (_ctx.component.size = $event))
    }, null, 8, ["font", "size"]),
    _hoisted_10,
    _createVNode("div", _hoisted_11, [
      _createVNode("div", _hoisted_12, [
        _withDirectives(_createVNode("input", {
          type: "number",
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (_ctx.component.x = $event))
        }, null, 512), [
          [
            _vModelText,
            _ctx.component.x,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_13,
        _hoisted_14
      ]),
      _createVNode("div", _hoisted_15, [
        _withDirectives(_createVNode("input", {
          type: "number",
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (_ctx.component.width = $event))
        }, null, 512), [
          [
            _vModelText,
            _ctx.component.width,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_16,
        _hoisted_17
      ])
    ]),
    _createVNode("div", _hoisted_18, [
      _createVNode("div", _hoisted_19, [
        _withDirectives(_createVNode("input", {
          type: "number",
          "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (_ctx.component.y = $event))
        }, null, 512), [
          [
            _vModelText,
            _ctx.component.y,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_20,
        _hoisted_21
      ]),
      _createVNode("div", _hoisted_22, [
        _withDirectives(_createVNode("input", {
          type: "number",
          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => (_ctx.component.height = $event))
        }, null, 512), [
          [
            _vModelText,
            _ctx.component.height,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_23,
        _hoisted_24
      ])
    ]),
    _createVNode("div", _hoisted_25, [
      _createVNode("div", _hoisted_26, [
        _withDirectives(_createVNode("input", {
          type: "number",
          "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => (_ctx.component.padding = $event))
        }, null, 512), [
          [
            _vModelText,
            _ctx.component.padding,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_27
      ])
    ]),
    _createVNode("p", _hoisted_28, [
      _hoisted_29,
      _createVNode("i", null, "%advancedgui_textinput_" + _toDisplayString(_ctx.component.id) + "%", 1),
      _hoisted_30
    ])
  ]))
})